
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/oferta-pracy/[slug]",
      function () {
        return require("private-next-pages/oferta-pracy/[slug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/oferta-pracy/[slug]"])
      });
    }
  